export const DISPLAY = {
	block: 'block',
	flex: 'flex',
	grid: 'grid',
	inline: 'inline',
	inlineBlock: 'inline-block',
	inlineFlex: 'inline-flex',
	inlineGrid: 'inline-grid',
	none: 'hidden',
} as const;

export type Display = keyof typeof DISPLAY;


export const DISPLAY_TABLET = {
	block: 'tablet:block',
	flex: 'tablet:flex',
	grid: 'tablet:grid',
	inline: 'tablet:inline',
	inlineBlock: 'tablet:inline-block',
	inlineFlex: 'tablet:inline-flex',
	inlineGrid: 'tablet:inline-grid',
	none: 'tablet:hidden',
} as const;

export type DisplayTablet = keyof typeof DISPLAY_TABLET;
